import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const translationRoutes: RouteObject[] = [
  {
    path: '/translations',
    element: lazyElement(() => import('./Translations')),
    handle: { crumb: () => ({ label: 'Translations', to: '/translations' }) },
  },
];

export default translationRoutes;

